"use client";

import { c as _c } from "react/compiler-runtime";
import clsx from "clsx";
import { isPast } from "date-fns";
import { SlotComponentProps } from "../availabilities/types";
import { colors } from "../slot-color-configs";
export function SlotComponent(t0) {
  const $ = _c(19);
  const {
    className,
    selectedCounterSlots,
    selectedSlot,
    slotValue,
    relationship
  } = t0;
  const isBuyer = relationship === "buyer";
  const isSeller = relationship === "seller";
  const showBuyer = isBuyer && selectedSlot || isSeller && selectedCounterSlots;
  const showSeller = isSeller && selectedSlot || isBuyer && selectedCounterSlots;
  const {
    badge,
    gradient
  } = colors;
  const buyerBadgeColor = badge[isBuyer ? "primary" : "secondary"];
  const sellerBadgeColor = badge[isSeller ? "primary" : "secondary"];
  const buyerSlotColor = badge[isBuyer ? "primary" : "secondary"];
  const sellerSlotColor = badge[isSeller ? "primary" : "secondary"];
  const gradientKey = `${isBuyer ? "primary" : "secondary"}-to-${isSeller ? "primary" : "secondary"}`;
  const matchingSlots = gradient[gradientKey as keyof typeof gradient];
  const defaultColor = isPast(new Date(slotValue)) ? "bg-white" : "";
  let t1;
  if ($[0] !== className) {
    t1 = clsx("flex items-center justify-between w-full relative", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== slotValue) {
    t2 = slotValue?.toString() || "";
    $[2] = slotValue;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = showBuyer && showSeller ? matchingSlots : showBuyer ? buyerSlotColor : showSeller ? sellerSlotColor : "";
  let t4;
  if ($[4] !== t3) {
    t4 = clsx("w-full h-full absolute top-0 left-0 opacity-10 rounded-full", t3);
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t4) {
    t5 = <div className={t4} />;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== buyerBadgeColor || $[9] !== defaultColor || $[10] !== sellerBadgeColor || $[11] !== showBuyer || $[12] !== showSeller) {
    t6 = showBuyer || showSeller ? <div className="flex items-center justify-between w-full flex-1"><div className="flex items-center p-1">{showBuyer && <div className={clsx("w-4 h-4 rounded-full text-white text-xs flex items-center justify-center font-small mix-blend-multiply", buyerBadgeColor)}>B</div>}</div><div className="flex items-center p-1">{showSeller && <div className={clsx("w-4 h-4 rounded-full text-white text-xs flex items-center justify-center font-small mix-blend-multiply", sellerBadgeColor)}>S</div>}</div></div> : <div className={clsx("w-full flex-1", defaultColor)}> </div>;
    $[8] = buyerBadgeColor;
    $[9] = defaultColor;
    $[10] = sellerBadgeColor;
    $[11] = showBuyer;
    $[12] = showSeller;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t1 || $[15] !== t2 || $[16] !== t5 || $[17] !== t6) {
    t7 = <div className={t1} id={t2}>{t5}{t6}</div>;
    $[14] = t1;
    $[15] = t2;
    $[16] = t5;
    $[17] = t6;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  return t7;
}